import { render, staticRenderFns } from "./FancyButton.vue?vue&type=template&id=aac81506&scoped=true&"
import script from "./FancyButton.vue?vue&type=script&lang=js&"
export * from "./FancyButton.vue?vue&type=script&lang=js&"
import style0 from "./FancyButton.vue?vue&type=style&index=0&id=aac81506&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac81506",
  null
  
)

export default component.exports